import styled, { css } from "styled-components";

export const CommonTdStyle = css`
  position: relative;
  padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
  line-height: 1.8rem;
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  vertical-align: top;
`;

export const CommonErrorStyles = css`
  background-color: ${({ theme }) => theme.color.neural.gray01};
  color: rgba(60, 71, 87, 0.5);

  a {
    color: rgba(60, 71, 87, 0.5);
  }

  span {
    color: rgba(60, 71, 87, 1);
  }
`;

export const CtgListTableBody = styled.tbody`
  background-color: #ffffff;
`;

export const CtgListTableTr = styled.tr<{
  isError: boolean;
}>`
  ${({ isError }) =>
    isError &&
    css`
      td {
        ${CommonErrorStyles}
      }
    `}
`;

export const CtgListTableId = styled.td`
  ${CommonTdStyle}
  width: 8rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
`;

export const CtgListTablePressId = styled.td`
  ${CommonTdStyle}
  width: 8rem;
  background: var(--Color-Common-Bg-Secondary, #f0f2f4);
`;

export const CtgListTableRegistryAgency = styled.td`
  ${CommonTdStyle}
  width: 7.2rem;
  min-width: 7.2rem;
  max-width: 8rem;
`;

export const CtgListTableCompany = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
  min-width: 8.8rem;
  max-width: 14.4rem;
  cursor: pointer;
  position: relative;

  &:hover {
    background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);
  }
`;

export const CtgListTableEditor = styled.td`
  ${CommonTdStyle}
  width: 7.2rem;
`;

export const RegistryDate = styled.td`
  ${CommonTdStyle}
  width: 7.2rem;
  min-width: 7.2rem;
  max-width: 8rem;
`;

export const PressListTableDate = styled.td`
  ${CommonTdStyle}
  width: 8rem;
`;

export const PressListTableUnsuitable = styled.td<{
  isUnsuitable: boolean;
  isModalOpen?: boolean;
}>`
  ${CommonTdStyle}
  width: 8.8rem;
  background-color: ${({ isUnsuitable }) =>
    isUnsuitable ? "rgba(219, 15, 114, 0.1)" : ""};

  &:hover {
    background-color: var(--Color-Common-Bg-Warning-Subtle, #feece6);
  }

  &:active {
    background: var(--Color-Common-Bg-Danger-Subtle, #fde7e9);
  }

  ${({ isModalOpen }) =>
    isModalOpen &&
    css`
      background: var(--Color-Common-Bg-Warning-Subtle, #feece6);
    `}
`;

export const PressListTablePublishable = styled.td`
  ${CommonTdStyle}
  width: 8.8rem;
  text-align: center;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
`;

export const StatusTableData = styled.td<{ code: string }>`
  ${CommonTdStyle}
  width: 7.2rem;
  text-align: center;
  vertical-align: middle;
`;

export const ClassificationTableData = styled.td<{
  status: string;
}>`
  ${CommonTdStyle}
  width: 13.6rem;

  ${({ status, theme }) =>
    ["S300"].includes(status) &&
    css`
      background-color: ${theme.color.neural.gray01};
      opacity: 0.5;
    `}
`;
